import axios from "axios";
import { useEffect, useState } from "react";

const NOMINATIM_BASE_URL = "https://nominatim.openstreetmap.org";

export interface AddressProps {
  street?: string;
  number?: string;
  district?: string;
  city?: string;
  state?: string;
  region?: string;
  country?: string;
}


export const getCoordinatesFromAddress = async (props: AddressProps): Promise<[number, number] | null> => {
  const { street, number, district, city, state, region, country } = props;

  const addressParts = [street, number, district, city, state, region, country].filter(
      (part) => part !== undefined && part !== null && part.trim() !== ""
  );

  if (addressParts.length === 0) return null;

  const queryText = addressParts.join(", ");

  try {
    const response = await axios.get(
        `${NOMINATIM_BASE_URL}/search?q=${encodeURIComponent(queryText)}&format=json`
    );

    if (response.data && response.data.length > 0) {
      return [Number(response.data[0].lat), Number(response.data[0].lon)];
    }

    console.warn("Nominatim não encontrou o local exato. Tentando busca ampla de contingência...");

    const fallbackParts = [street, district, city, state, country].filter(
        (part) => part !== undefined && part !== null && part.trim() !== ""
    );
    const fallbackText = fallbackParts.join(", ");

    const fallbackResponse = await axios.get(
        `${NOMINATIM_BASE_URL}/search?q=${encodeURIComponent(fallbackText)}&format=json`
    );

    if (fallbackResponse.data && fallbackResponse.data.length > 0) {
      return [Number(fallbackResponse.data[0].lat), Number(fallbackResponse.data[0].lon)];
    }

  } catch (error) {
    console.error("Error fetching nominatim coordinates by address: ", error);
  }

  return null;
};

const useFetchCoordinatesFromAddress = (props: AddressProps) => {
  const { city, street, number, district, state } = props;
  const [coordinates, setCoordinates] = useState<[number, number]>([0, 0]);

  useEffect(() => {
    if (!city) return;

    getCoordinatesFromAddress(props)
        .then((response) => {
          if (response) {
            setCoordinates(response);
          }
        })
        .catch((error) => {
          console.error("ERRO COORD:", error);
        });

  }, [city, street, number, district, state]);

  return { coordinates };
};

export default useFetchCoordinatesFromAddress;